import Component from '../core/Component';
import $ from 'jquery';

export default class Tabs extends Component
{
    constructor($element)
    {
        super($element)
        this.$links = this.$element.find('a')
    }

    prepare()
    {
        this.$links.on('click', ::this.handleClick)
        this.$links.each((index, item) => {
            if (window.location.hash == $(item).attr('href')) {
                this.$links.each(function (event) {
                    $($(this).attr('href')).removeClass('is-active')
                    $(this).parents('li').removeClass('is-active')
                })
                $($(item).attr('href')).addClass('is-active')
                $(item).parents('li').addClass('is-active')
            }
        })
    }

    handleClick (event) {
        event.preventDefault()
        event.stopPropagation()

        this.$links.each(function (event) {
            $($(this).attr('href')).removeClass('is-active')
            $(this).parents('li').removeClass('is-active')
        })
        $($(event.target).attr('href')).addClass('is-active')
        $(event.target).parents('li').addClass('is-active')

        if (history.replaceState) {
            history.replaceState(null, null, $(event.target).attr('href'))
        }  else {
            location.hash = $(event.target).attr('href')
        }
    }

    activate () {

    }
}


// WEBPACK FOOTER //
// ./components/Tabs.js